import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import MailchimpSubscribe from "react-mailchimp-subscribe";

const url = "//xxxx.us13.list-manage.com/subscribe/post?u=zefzefzef&id=fnfgn";

const SimpleForm = () => <MailchimpSubscribe url={url} />;

function Footer() {
  const userRole = localStorage.getItem('userRole');
  const [settinglist, setSettingsData] = useState([]);
  const [pageslist, setPagesList] = useState([]);
  const [error, setError] = useState(null);

  const API_URL = `${process.env.REACT_APP_API_URL}/setting/getsetting`;
  const Footer_Pages_API_URL = `${process.env.REACT_APP_API_URL}/pages/`;
  const TOKEN = localStorage.getItem('adminToken');

  const fetchSettingsData = async () => {
    try {
      const res = await fetch(API_URL);
      const data = await res.json();
      setSettingsData(data['data'] || []);
    } catch (err) {
      setError('Failed to fetch settings data');
      console.error('Error fetching settings:', err);
    }
  };

  const getFootermenus = async () => {
    try {
      const footer_menu_resp = await axios.get(Footer_Pages_API_URL, {
        headers: {
          Authorization: `Bearer ${TOKEN}`,
        },
      });
      setPagesList(footer_menu_resp.data.data || []);
    } catch (error) {
      setError('Failed to fetch footer menus');
      console.error('Footer Menus not working due to error:', error);
    }
  };

  useEffect(() => {
    fetchSettingsData();
    getFootermenus();
  }, []);

  if (error) {
    return <div className="error-message">{error}</div>;
  }

  return (
    <>
      {userRole !== '1' && (
        <>
          <section className="newsletter-sec">
            <img src="./img/heart-bg.png" alt="" className="fixed_bg" />
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <h2>Subscribe to Our Newsletter for Daily Updates!</h2>
                  <p>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Nullam bm egestas orc tortor turpis retium quis est sit ame
                  </p>
                </div>
                <div className="col-md-6">
                  <div className="input-group mb-0 newsletter-search-form newsletter_form">
                    <MailchimpSubscribe
                      url={url}
                      render={({ subscribe, status, message }) => (
                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            const email = e.target.email.value;
                            subscribe({ EMAIL: email });
                          }}
                          className="newsletter-form"
                        >
                          <input
                            type="email"
                            name="email"
                            placeholder="Enter your email"
                            required
                            className="newsletter-input"
                          />
                          <button type="submit" className="newsletter-button">Submit</button>
                          {status === "sending" && <div style={{ color: "blue" }}>Sending...</div>}
                          {status === "error" && <div style={{ color: "red" }} dangerouslySetInnerHTML={{ __html: message }} />}
                          {status === "success" && <div style={{ color: "green" }}>Subscribed!</div>}
                        </form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>

          {settinglist.map((settinglistData, key) => (
            <div key={key}>
              {settinglistData.footer_section && (
                <div className="dynamic-footer" dangerouslySetInnerHTML={{ __html: settinglistData.footer_section }} />
              )}
            </div>
          ))}

          <footer className="footerMain bg-dark">
            <div className="container">
              <div className="foote-wrap">
                <ul className="f_link">
                  {pageslist.map((page) => (
                    page.template === 2 && page.top_menu === 0 ? (
                      <li className="nav-item" key={page.id}>
                        {page.slug === 'home' ? (
                          <Link className="nav-link" to="/">
                            {page.pagetitle}
                          </Link>
                        ) : (
                          <Link className="nav-link" to={`/${page.slug}`}>
                            {page.pagetitle}
                          </Link>
                        )}
                      </li>
                    ) : null
                  ))}
                  <li>
                    <p className="copyrightbox">
                      Copyright © 2024 Foreignchatweb. All rights reserved 2024
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </footer>
        </>
      )}
    </>
  );
}

export default Footer;